module.exports = __webpack_public_path__ + "static/media/trash-2.b061bd3f.svg";